import React from 'react';
import './Testimonials.css';

export default function Testimonials() {
  // Testimonial data
  const testimonials1 = [
    {
      id: 1,
      name: 'Jaisimha A G',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg', // Placeholder image, replace with actual
      rating: 5,
      timeAgo: 'a month ago',
      text: 'A pretty well organized warehouse for most hobby electronic components and modules. Your online shopping experience is comfortable and convenient',
      source: 'google'
    },
    {
      id: 2,
      name: 'Anirban Bandyopadhyay',
      avatar: 'https://randomuser.me/api/portraits/men/45.jpg', // Placeholder image, replace with actual
      rating: 5,
      timeAgo: 'a month ago',
      text: 'With the price, service, and guidance, Robocraze is a complete package for your needs',
      source: 'google'
    },
    {
      id: 3,
      name: 'Varun Wahi',
      avatar: 'https://randomuser.me/api/portraits/men/68.jpg', // Placeholder image, replace with actual
      rating: 5,
      timeAgo: '3 weeks ago',
      text: 'Great customer service. I am very impressed with the quick replies and actions to all my queries.',
      source: 'google'
    }
  ];

  // Render stars for ratings
  const renderStars1 = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span 
          key={i} 
          className={`star1 ${i < rating ? 'filled1' : 'empty1'}`}
        >
          ★
        </span>
      );
    }
    return stars;
  };

  // Render source icon
  const renderSourceIcon1 = (source) => {
    if (source === 'google') {
      return (
        <div className="testimonial-source1 google1">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="testimonials-section1">
      <h2 className="testimonials-heading1">Testimonials</h2>
      
      <div className="testimonials-container1">
        {testimonials1.map(testimonial => (
          <div key={testimonial.id} className="testimonial-card1">
            <div className="testimonial-header1">
              <div className="testimonial-avatar1">
                <img src={testimonial.avatar} alt={testimonial.name} />
                {testimonial.verified && <span className="verified-badge1">✓</span>}
              </div>
              <div className="testimonial-user-info1">
                <h3 className="testimonial-name1">{testimonial.name}</h3>
                <div className="testimonial-rating1">
                  {renderStars1(testimonial.rating)}
                  <span className="testimonial-time1">{testimonial.timeAgo}</span>
                </div>
              </div>
              {renderSourceIcon1(testimonial.source)}
            </div>
            <p className="testimonial-text1">{testimonial.text}</p>
          </div>
        ))}
      </div>
    </div>
  );
}